import React, { Component } from 'react';
import App from "../../App";
import { FaLongArrowAltLeft } from "react-icons/all";
import "../../assets/scss/invoice.scss";
import { withRouter, Link } from "react-router-dom";
import { getDetails } from "../../services/baseServices";
import { getFormattedDate } from '../../helper/utils';
import ExportCSV from '../common/ExportCSV';

const headers = [
    { label: "Order No", key: "id" },
    { label: "Reconciled Date", key: "reconciled_date" },
    { label: "Total Price", key: "amount" },
    { label: "Shipping Type", key: "shipping_type" },
  ];

class DepositDetails extends Component {
    state = {
		depositDetails: {},
    }

    componentDidMount() {
        getDetails("bank_transactions", this.props.match.params.id)
        .then((res) => {
            this.setState({ depositDetails: res?.data });
        })
        .catch((errMsg) => {
            console.log("Error Message: ", errMsg);
        });
    }

    render() {
        const { depositDetails } = this.state
        return (
            <App layout="">
                <div className="main-content">
                    <div className="page-header">
                        <h2 className="page-title">Deposit Details</h2>
                        <div className="ml-auto">
                            <Link to={`${process.env.PUBLIC_URL}/cash-deposit/list`}
                                className="btn btn-sm btn-link"><FaLongArrowAltLeft/> Back to Deposit List
                            </Link>
                        </div>
                    </div>
                <div className="card-block">
                    <div className="block-body">
                        <table className='mb-3'>
                            <tbody>
                                <tr>
                                    <td>
                                        <span className="d-block"><strong>Transaction Id</strong> : {depositDetails.transaction_id}</span>
                                        <span className="d-block"><strong>Transaction Date</strong> : {getFormattedDate(depositDetails.collection_date,"DD-MM-YYYY")}</span>
                                        <span className="d-block"><strong>Total Amount</strong> : {depositDetails.amount}</span>
                                        <span className="d-block"><strong>Bank Name</strong> : {depositDetails.to_bank}</span>
                                        <span className="d-block"><strong>Status</strong> : {depositDetails.is_approved? "Received": "Not received yet"}</span>
                                        <span className="d-block"><strong>Chalan No</strong> : {depositDetails?.chalan_no}</span>
                                        <span className="d-block"><strong>Chalan Copy</strong> :{" "} 
                                        {
                                            depositDetails?.chalan_images?.map((img, i)=>(
                                                <img className="mr-2" src={img.url} key={i} width={100} height={100}/>
                                            ))
                                        }
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div className="block-header">
                            <h4 className="block-title">Customer Orders</h4>
                            <div className="ml-auto">
                                {
                                    depositDetails?.customer_orders &&
                                    <ExportCSV  data={depositDetails?.customer_orders} headers={headers} title="Customer Orders"/>
                                }
                            </div>
                        </div>
                        <table className='table table-bordered'>
                            <thead>
                                <tr>
                                    <th style={{ width: "20px" }}>#</th>
                                    <th>Order ID</th>
                                    <th>Reconciled Date</th> 
                                    <th>Amount</th>
                                    <th>Shipping Type</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    depositDetails?.customer_orders?.map((item,index)=>{
                                        return(
                                            <tr key={item.id}>
                                                <td>{index + 1}</td>
                                                <td>
                                                    <div className="order-item">
                                                        {item.id}
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="order-item">
                                                        {getFormattedDate(item.reconciled_date, "DD-MM-YYYY")}
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="order-item">
                                                        {item.amount}
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="order-item">
                                                        {item.shipping_type}
                                                    </div>
                                                </td>
                                            </tr>
                                        )
                                    })
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            </App>
        );
    }
}

export default withRouter(DepositDetails);
